module.exports = __webpack_public_path__ + "img/title.c26f3667.jpg";